class Analytics {
  constructor() {
    this.enabled = import.meta.env.PROD;
  }

  trackEvent(category, action, label = null, value = null) {
    if (!this.enabled) {
      // В режиме разработки просто логируем в консоль
      console.log(`[Analytics DEV] ${category}: ${action}`, { label, value });
      return;
    }
    
    try {
      if (window.gtag) {
        window.gtag('event', action, {
          event_category: category,
          event_label: label,
          value: value
        });
      }
      
      console.log(`[Analytics] ${category}: ${action}`, { label, value });
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }

  trackBooking(court, date, timeSlots) {
    this.trackEvent('Booking', 'create', `${court}_${date}`, timeSlots.length);
  }

  trackCertificate(nominal) {
    this.trackEvent('Certificate', 'order', nominal);
  }

  trackPhoneClick() {
    this.trackEvent('Contact', 'phone_click');
  }

  trackSocialClick(platform) {
    this.trackEvent('Social', 'click', platform);
  }
}

export const analytics = new Analytics();